<template>
  <component
    :is="sidepanelComponent"
    class="mh-100 h-100"
  />
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import {
  BUILDER_SIDEPANELS,
} from '@/views/builder/builderComponentDefinitions'

@Component
export default class BuilderSidebar extends Vue {
  get sidepanel () {
    return this.$typedStore.currentRoute.sidepanel
  }

  get sidepanelComponent () {
    return BUILDER_SIDEPANELS.find(({ sidepanel }) => sidepanel === this.sidepanel)?.component
  }
}
</script>
